export default __webpack_public_path__ + "static/media/play.68b0b4ca.png";